// extracted by mini-css-extract-plugin
export default {"MainCont":"Packaging_MainCont__2ptP9","LeftCont":"Packaging_LeftCont__YdXTN","RightCont":"Packaging_RightCont__cfxm4"};